import React, { useState } from 'react';

// Controls the rendering, message, and duration of the popup alert.
const SnackbarAlertContext = React.createContext({
	isSnackbarOpen: false,
	autoHide: undefined,
	msg: undefined,
	severity: undefined,
});

// SnackbarAlertContextProvider is used to give all children components access to the SnackbarAlertContext context.
// Wrap components that need access to the SnackbarAlertContext with the SnackbarAlertContextProvider context.
export const SnackbarAlertContextProvider = (props) => {
	const [snackbarAlert, setSnackbarAlertState] = useState({
		isSnackbarOpen: false,
		autoHide: undefined,
		msg: undefined,
		severity: undefined,
	});

	// Wrapper function with default values for isSnackbarOpen and autoHide
	const setSnackbarAlert = (alertConfig) => {
		// Handle function updater pattern (for closing snackbar)
		if (typeof alertConfig === 'function') {
			setSnackbarAlertState(alertConfig);
		} else {
			// Handle object pattern with defaults
			setSnackbarAlertState({
				isSnackbarOpen: true, // Default to true
				autoHide: 8000, // Default to 8 seconds
				...alertConfig, // Allow overriding defaults
			});
		}
	};

	return (
		<SnackbarAlertContext.Provider value={{ snackbarAlert, setSnackbarAlert }}>
			{props.children}
		</SnackbarAlertContext.Provider>
	);
};

export default SnackbarAlertContext;
